// extracted by mini-css-extract-plugin
module.exports = {"container":"bi-z","error":"ci-z","disabled":"di-z","submit":"ei-z","option":"fi-z","success":"gi-z","failure":"hi-z"};